import React from "react";
import { Carousel, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import bannerData from "../../../data/homeBanner";
import "./HomeBanner.css";

export default function HomeBanner() {
    return (
        <section className="hb">
            <Carousel
                className="hb-carousel"
                indicators
                controls
                interval={7000}
                pause="hover"
                fade={false}
                variant="dark"
            >
                {bannerData.map((item) => (
                    <Carousel.Item className="hb-slide" key={item.id}>
                        <SlideMedia item={item} />

                        {/* Right aligned overlay content */}
                        <div className="hb-overlay">
                            <Container fluid="lg" className="hb-overlay__container">
                                <div className="hb-overlay__content">
                                    {item.title ? <h3 className="hb-title">{item.title}</h3> : null}
                                    {item.subtitle ? <p className="hb-subtitle">{item.subtitle}</p> : null}
                                    {item.ctaText && item.ctaHref ? (
                                        <div className="hb-cta">
                                            <Link to={item.ctaHref} className="lk-brand-btn-1">
                                                {item.ctaText}
                                            </Link>
                                        </div>
                                    ) : null}
                                </div>
                            </Container>
                        </div>
                    </Carousel.Item>
                ))}
            </Carousel>
        </section>
    );
}

/**
 * SlideMedia
 * - Renders <video> when type=video
 * - Falls back to <img> if video errors or if type=image
 */
function SlideMedia({ item }) {
    const [useImageFallback, setUseImageFallback] = React.useState(false);

    // Respect reduced motion: if user prefers reduced motion, don't autoplay video
    const prefersReducedMotion = usePrefersReducedMotion();

    if (item.type === "video" && !useImageFallback && !prefersReducedMotion) {
        return (
            <div className="hb-media">
                <video
                    className="hb-video"
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="auto"
                    poster={item.poster || item.fallbackImg || undefined}
                    onError={() => setUseImageFallback(true)}
                >
                    <source src={item.videoSrc} type="video/mp4" />
                    {/* If the browser can't play the video tag, we show image below via state change */}
                </video>
            </div>
        );
    }

    // Image (explicit or fallback)
    const imgSrc =
        item.imageSrc ||
        item.poster ||
        item.fallbackImg ||
        "/assets/images/banner-fallback-generic.jpg";

    return (
        <div className="hb-media">
            <img className="hb-img" src={imgSrc} alt={item.title || "Banner"} />
        </div>
    );
}

/**
 * Hook: prefers-reduced-motion
 */
function usePrefersReducedMotion() {
    const [reduced, setReduced] = React.useState(false);
    React.useEffect(() => {
        const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
        const update = () => setReduced(!!mq.matches);
        update();
        mq.addEventListener?.("change", update);
        return () => mq.removeEventListener?.("change", update);
    }, []);
    return reduced;
}
